import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWelcome = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 140,
	viewBox: "0 0 185 140",
	width: 185,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "m96.7012 48.0053c-10.7154-10.6589-28.0427-10.613-38.7017.1024-8.9301 8.9776-10.5351 22.9093-3.8799 33.6823l-3.4794 13.0386 13.4024-3.5761c13.218 7.3294 29.8748 2.5558 37.2044-10.6621 5.912-10.6618 4.058-23.9484-4.5458-32.5851z",
				stroke: "#0050a0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m91.0374 48.0053c10.7156-10.6589 28.0426-10.613 38.7016.1024 8.93 8.9776 10.535 22.9093 3.88 33.6823l3.479 13.0386-13.402-3.5761c-13.218 7.3294-29.8748 2.5558-37.2042-10.6621-5.912-10.6618-4.0585-23.9484 4.5456-32.5851z",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m89.3835 67.6719h9.1003",
				stroke: "#0050a0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m93.9336 63.1211v9.1003",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m1.67023 89.1387h34.85237",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m1.34241 70.8111 17.75399-6.1197 17.4266 6.1197",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsxs("g", {
				stroke: "#0050a0",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m6.64905 72.9922v11.9658" }),
					/* @__PURE__ */ _jsx("path", { d: "m11.628 72.9922v11.9658" }),
					/* @__PURE__ */ _jsx("path", { d: "m16.6069 72.9922v11.9658" }),
					/* @__PURE__ */ _jsx("path", { d: "m26.5647 72.9922v11.9658" }),
					/* @__PURE__ */ _jsx("path", { d: "m31.5436 72.9922v11.9658" }),
					/* @__PURE__ */ _jsx("path", { d: "m21.5858 72.9922v11.9658" }),
					/* @__PURE__ */ _jsx("path", { d: "m27.4159 102.033h12.2535c.8158 0 1.4772.662 1.4772 1.477v15.086" })
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m29.4142 118.596h17.7676",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsxs("g", {
				stroke: "#0050a0",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m23.0099 105.945c.6957-4.237-2.9153-7.8486-7.152-7.1538-2.5653.4207-4.6343 2.4898-5.0552 5.0548-.6952 4.237 2.9143 7.848 7.1507 7.153 2.5657-.42 4.6352-2.489 5.0565-5.054z" }),
					/* @__PURE__ */ _jsx("path", { d: "m29.305 128.919-3.5286-8.592c-1.4775-3.597-4.9813-5.946-8.8702-5.946s-7.39276 2.349-8.87021 5.946l-3.5286 8.592" }),
					/* @__PURE__ */ _jsx("path", { d: "m10.9738 128.896v-5.511" }),
					/* @__PURE__ */ _jsx("path", { d: "m22.8387 128.94v-5.51" })
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m180.158 71.357h-10.5v-6.4h10.5l3.5 3.2z",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m159.158 71.3574h10.5v6.4h-10.5l-3.5-3.2z",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m169.658 64.957v28.0008",
				stroke: "#0050a0"
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .5,
				stroke: "#0050a0",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m54.9046 126.184c10.9313 8.034 24.4226 12.789 39.0291 12.789 14.6063 0 28.0973-4.755 39.0293-12.789" }),
					/* @__PURE__ */ _jsx("path", {
						d: "m133.329 109.209c-9.617 10.925-23.696 17.828-39.3953 17.828-15.6992 0-29.7783-6.903-39.3955-17.828",
						strokeDasharray: "8 8"
					}),
					/* @__PURE__ */ _jsx("path", { d: "m116.549 109.209c-6.543 4.147-14.296 6.554-22.6154 6.554-8.3193 0-16.0725-2.407-22.6151-6.554" })
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .5,
				stroke: "#0050a0",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m93.9337 30.1664v-28.25038" }),
					/* @__PURE__ */ _jsx("path", { d: "m80.8876 31.8211-9.4457-25.95196" }),
					/* @__PURE__ */ _jsx("path", { d: "m66.6929 35.1946-15.0343-17.9173" }),
					/* @__PURE__ */ _jsx("path", { d: "m52.6037 43.7879-15.6338-9.0262" }),
					/* @__PURE__ */ _jsx("path", { d: "m107.073 31.5786 9.348-25.68407" }),
					/* @__PURE__ */ _jsx("path", { d: "m120.792 35.6754 15.4-18.3531" }),
					/* @__PURE__ */ _jsx("path", { d: "m135.597 43.6372 15.264-8.813" })
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m172.504 114.684c4.362.029 7.874 3.588 7.845 7.95-.029 4.363-3.588 7.877-7.951 7.848-4.363-.028-7.876-3.587-7.848-7.95s3.588-7.876 7.951-7.848z",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m154.502 122.466c-.028 4.363-3.587 7.877-7.95 7.848-4.363-.028-7.876-3.587-7.848-7.95s3.588-7.876 7.95-7.848c4.363.028 7.877 3.588 7.848 7.95z",
				stroke: "#e6007d"
			}),
			/* @__PURE__ */ _jsxs("g", {
				stroke: "#0050a0",
				children: [
					/* @__PURE__ */ _jsx("path", { d: "m152.333 112.031 13.07 1.409 7.046 9.145" }),
					/* @__PURE__ */ _jsx("path", { d: "m146.609 122.41 7.261-13.789-3.679-.287" }),
					/* @__PURE__ */ _jsx("path", { d: "m164.388 109.709 4.571.03" }),
					/* @__PURE__ */ _jsx("path", { d: "m159.832 95.8998c2.199.0094 3.988-1.7647 3.998-3.9629 0-.0006 0-.0013 0-.0019.008-2.1986-1.767-3.9881-3.965-3.9975-2.199-.0085-3.988 1.7663-3.997 3.9649-.007 2.1935 1.764 3.9784 3.957 3.9888z" }),
					/* @__PURE__ */ _jsx("path", { d: "m165.363 107.18c-5.083-.033-9.472 6.988-6.175 13.964h.028l-2.357.565" }),
					/* @__PURE__ */ _jsx("path", { d: "m154.261 106.278c4.529.028 8.224-3.62 8.253-8.1491" }),
					/* @__PURE__ */ _jsx("path", { d: "m162.513 98.1309 2.85 9.0501" })
				]
			})
		]
	})
});
export default SvgWelcome;
